// extracted by mini-css-extract-plugin
export default {"updatingOverlay":"TemplateFileCard_updatingOverlay__WgSBh"};